import especialidade from '@/repositories/conecta-sus/cadastro/especialidadeRepository'
import ferida from '@/repositories/conecta-sus/cadastro/feridaRepository'
import estabelecimento from '@/repositories/conecta-sus/cadastro/estabelecimento/index'
import fabricante from '@/repositories/conecta-sus/cadastro/fabricante/fabricanteRepository'
import feriado from '@/repositories/conecta-sus/cadastro/feriado/index'
import fornecedor from '@/repositories/conecta-sus/cadastro/fornecedor/fornecedorRepository'
import grupo from '@/repositories/conecta-sus/cadastro/grupo/grupoRepository'
import localizacao from '@/repositories/conecta-sus/cadastro/localizacao/index'
import material from '@/repositories/conecta-sus/cadastro/material/materialRepository'
import materialBnafar from '@/repositories/conecta-sus/cadastro/materialBnafarRepository'
import medicamento from '@/repositories/conecta-sus/cadastro/medicamento/index'
import medicamentoNaoPadronizado from '@/repositories/conecta-sus/cadastro/medicamentoNaoPadronizadoRepository'
import obito from '@/repositories/conecta-sus/cadastro/obitoRepository'
import oci from '@/repositories/conecta-sus/cadastro/ociRepository'
import origemProgramatica from '@/repositories/conecta-sus/cadastro/origemProgramaticaRepository'
import parametrizacao from '@/repositories/conecta-sus/cadastro/parametrizacao/parametrizacaoRepository'
import relatorioMaterial from '@/repositories/conecta-sus/cadastro/relatorioMaterialRepository'
import relatorioPacienteBairro from '@/repositories/conecta-sus/cadastro/relatorioPacienteBairroRepository'
import relatorioUsuario from '@/repositories/conecta-sus/cadastro/relatorioUsuarioRepository'
import servicoManutencao from '@/repositories/conecta-sus/cadastro/servicoManutencaoRepository'
import subgrupo from '@/repositories/conecta-sus/cadastro/subgrupo/subgrupoRepository'
import sujeitoAtencao from '@/repositories/conecta-sus/cadastro/sujeito-atencao/index'
import supervisor from '@/repositories/conecta-sus/cadastro/supervisorRepository'
import unidadeExecutanteManutencao from '@/repositories/conecta-sus/cadastro/unidadeExecutanteManutencaoRepository'
import unificacaoUsuarioPaciente from '@/repositories/conecta-sus/cadastro/unificacaoUsuarioPacienteRepository'
import usuarioPerfil from '@/repositories/conecta-sus/cadastro/usuarioPerfilRepository'
import vacina from '@/repositories/conecta-sus/cadastro/vacinaRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/cadastro`

    return {
        especialidade: especialidade(baseUrl),
        ferida: ferida(baseUrl),
        estabelecimento: estabelecimento(baseUrl),
        fabricante: fabricante(baseUrl),
        feriado: feriado(baseUrl),
        fornecedor: fornecedor(baseUrl),
        grupo: grupo(baseUrl),
        localizacao: localizacao(baseUrl),
        material: material(baseUrl),
        materialBnafar: materialBnafar(baseUrl),
        medicamento: medicamento(baseUrl),
        medicamentoNaoPadronizado: medicamentoNaoPadronizado(baseUrl),
        obito: obito(baseUrl),
        oci: oci(baseUrl),
        origemProgramatica: origemProgramatica(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
        relatorioMaterial: relatorioMaterial(baseUrl),
        relatorioPacienteBairro: relatorioPacienteBairro(baseUrl),
        relatorioUsuario: relatorioUsuario(baseUrl),
        servicoManutencao: servicoManutencao(baseUrl),
        subgrupo: subgrupo(baseUrl),
        sujeitoAtencao: sujeitoAtencao(baseUrl),
        supervisor: supervisor(baseUrl),
        unidadeExecutanteManutencao: unidadeExecutanteManutencao(baseUrl),
        unificacaoUsuarioPaciente: unificacaoUsuarioPaciente(baseUrl),
        usuarioPerfil: usuarioPerfil(baseUrl),
        vacina: vacina(baseUrl),
    }
}